import ServerDirections from '@/config/server-directions'
import { Room } from '@/entities/Room'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

export class RoomRequests {
  list () {
    const route = ServerDirections.ROOMS
    const method = 'get'
    function map (data) {
      return data.map(item => new Room(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }
}